import { createContext } from 'react';
import { noop } from 'lodash/fp';

const NotificationContext = createContext({
  addNotification: noop,
  removeNotification: noop,
});

export default NotificationContext;
